import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Timestamp, doc, getDoc, setDoc } from "firebase/firestore";
import { userRole } from "../../../fakes/FRoles";
import { User } from "../../models/Models";
import { auth, firestore } from "../../utils/firebase";
import IAuthRepository from "./IAuthRepository";


export class FirebaseAuthRepository extends IAuthRepository {
    private provider: GoogleAuthProvider = new GoogleAuthProvider();
    private currentUser?: User;

    login: () => Promise<User | undefined> = async () => {
        try {
            const user = await signInWithPopup(auth, this.provider);
            const userDoc = await getDoc(doc(firestore, `users/${user.user.uid}`));
            const userData: User = {
                email: user.user.email!,
                username: user.user.displayName!,
                id: user.user.uid,
                imageUrl: `https://api.dicebear.com/7.x/pixel-art/svg?seed=${user.user.email}`,
                creationDate: Timestamp.now().toMillis(),
                createdAt: Timestamp.now(),
                updatedAt: Timestamp.now(),
            };
            if (userDoc.exists()) {
                userData.role = userDoc.data().role;
            } else {
                userData.role = userRole;
                setDoc(doc(firestore, `users/${user.user.uid}`), userData);
            }
            this.currentUser = userData;
            return userData;
        } catch (error) {
            console.error(error);
            return undefined;
        }
    }
    logout: () => Promise<void> = async () => {
        try {
            await auth.signOut();
            this.currentUser = undefined;
        } catch (error) {
            console.error(error);
        }
    }
    getCurrentUser: () => Promise<User | undefined> = async () => {
        try {
            if (this.currentUser != null) {
                return this.currentUser;
            } else if (auth.currentUser != null) {
                const userDoc = await getDoc(doc(firestore, `users/${auth.currentUser.uid}`));
                if (userDoc.exists()) {
                    this.currentUser = userDoc.data() as User;
                    return this.currentUser;
                }
            }
        } catch (error) {
            console.error(error);
        }
        return undefined;
    }
}